
import React from "react";
import { Paper, Box } from "@mui/material";
import CustomText from "../CustomText";

const InfoCard = ({ icon, title, description, onClick, sx,isOpen, }) => {
  return (

    <Paper
      elevation={0}
      sx={{
        py: 2,
        px: 2,
        // border: "1px solid #CFCFCF",
        borderRadius: "8px",
        backgroundColor: "white",
        boxShadow: "0px 4px 25px 0px rgba(141, 141, 141, 0.05)",
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick
          ? {
              boxShadow: "0px 4px 25px 0px rgba(141, 141, 141, 0.1)",
            }
          : {},
        ...sx,
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        {/* Left: Title + Description in a column */}
        <Box sx={{ flex: 1 }}>
          <CustomText
            customStyle={{
              fontSize: "20px",
              fontWeight: 600,
              fontFamily: "Poppins, sans-serif",
              color: "#100F0F",
              textAlign: "left",
              marginBottom: "20px",
            }}
          >
            {title}
          </CustomText>
          <Box
            sx={{
            
              // overflow: "hidden",
              transition: "max-height 0.5s ease-in-out, opacity 0.3s ease-in-out",
              transitionDelay: isOpen ? "0s, 0.2s" : "0s, 0s",
            }}
          >
          <CustomText
          style={{
              fontSize: "15px",
              fontWeight: 500,
              fontFamily: "Nunito, sans-serif",
              color: "#5E5C5C",
              textAlign: "left",
              lineHeight: "150%",
              marginTop:"10px"
            }}
          >
            {description}
          </CustomText>
          </Box>
        </Box>

        {/* Right: Icon */}
        {icon && (
          <Box
            sx={{
              width: 40,
              height: 40,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icon}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default InfoCard;
